<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-archive"></i> {{ _('Archived reports') }}</h3>
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Display') }}</div>
              <select class="form-control" id="reportTypeFilter" v-model="type">
                <option value="all">{{ _('All reports') }}</option>
                <optgroup :label="_('Accounting reports')">
                  <option v-for="rt in accountingReportTypes" :value="rt.id">{{ rt.name }}</option>
                </optgroup>
                <optgroup :label="_('List reports')">
	  						  <option v-for="rt in listReportTypes" :value="rt.id">{{ rt.name }}</option>
  						  </optgroup>
                <optgroup :label="_('Movie reports')">
                  <option v-for="rt in movieReportTypes" :value="rt.id">{{ rt.name }}</option>
                </optgroup>
                <optgroup :label="_('Reservation reports')">
                  <option v-for="rt in reservationReportTypes" :value="rt.id">{{ rt.name }}</option>
                </optgroup>
                <optgroup :label="_('Other reports')">
                  <option v-for="rt in otherReportTypes" :value="rt.id">{{ rt.name }}</option>
                </optgroup>
              </select>
            </div>
          </div>
        </div>
      </div>
      <Datatable :url="reportUrl" :search="search" :type-filter="type" :options="tableOptions" v-on:data="tableEvent" ref="datatable" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, ReportActions } from '#components'
import settingshelpers from '~/lib/settingshelpers'
import reporttypes from '~/lib/reporttypes'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      reports: [],
      search: '',
      type: 'all',
      selectedReport: {},
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [{
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Date'),
          field: 'ts',
          widthGrow: 2,
          formatter: $this.dateAndTimeFormatter(),
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'title',
          widthGrow: 5
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 3,
          formatter: $this.reportTypeFormatter()
        },
        {
          title: _('Creator'),
          field: 'creator',
          widthGrow: 2
        }],
        initialSort: [{
          column: 'ts',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.selectRow(row)
        }
      }
    }
  },
  mixins: [components, formatters, reporttypes, settingshelpers],
  computed: {
    modalId () {
      return this.column.identifier + '-component-' + this.component.id + '-archivedreportlist'
    },
    reportUrl () {
      return this.baseDomain + this.shopId + '/archivedreports.json?apikey=' + this.apiKey + '&rawformat=true'
    }
  },
  methods: {
    isOdd (i) {
      return i % 2
    },
    selectRow (row) {
      const $this = this
      let report = {
        id: row.getCell('id').getValue(),
        title: row.getCell('title').getValue(),
        ts: row.getCell('ts').getValue(),
        type: row.getCell('type').getElement().innerText,
        typeValue: row.getCell('type').getValue(),
        duration: row.getData().duration,
        isFeatureEnabled: this.isFeatureEnabled
      }
      this.selectedReport = report
      this.showModal('actions', ReportActions, {
        props: {
          report: report
        },
        events: {
          copyReport: this.copyReport,
          openReport: this.openReport,
          openReportXLSX: this.openReportXLSX,
          openReportPDF: this.openReportPDF,
          resendReport: this.resendReport,
          viewStatisticsReport: this.viewStatisticsReport
        },
        width: '100%',
        maxWidth: 800
      })
    },
    openReport (id) {
      const url = this.archivedReportUrl(id, 'html', this.selectedReport.typeValue)
      if (url) {
        window.open(url)
      }
    },
    openReportXLSX (id) {
      const url = this.archivedReportUrl(id, 'xlsx', this.selectedReport.typeValue)
      if (url) {
        window.open(url)
      }
    },
    openReportPDF (id) {
      const url = this.archivedReportUrl(id, 'pdf', this.selectedReport.typeValue)
      if (url) {
        window.open(url)
      }
    },
    async viewStatisticsReport (id) {
      let reportData = await this.resendReport(id, true)
      if (!reportData) {
        return
      }
      this.showDialog({
        title: this._('Statistics Finland report'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
        ],
        fields: [
          {
            type: 'xml',
            name: 'data',
            defaultValue: reportData.data
          }
        ]
      })
    },
    async resendReport (id, viewOnly = false) {
      let response = null
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/archivedreports/' + id + '.json?apikey=' + this.apiKey)
      } catch (e) {
        console.error(e)
        return
      }
      let report = response.data
      let params = null
      try {
        params = JSON.parse(report.params)
      } catch(e) {
        this.showNotification(this._('Error loading report data.'))
        return
      }
      if (params) {
        return this.sendStatisticsFinlandData(params.start, params.end, viewOnly)
      }
    },
    async sendStatisticsFinlandData(start, end, viewOnly = false) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/statisticsfinland.json?apikey=' + this.apiKey, { start: start, end: end, viewOnly: viewOnly })
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errorMessage) {
          this.showError(e.response.data.errorMessage)
          return
        }
      }
      if (viewOnly) {
        return response.data
      }
      if (response && response.data) {
        this.showNotification(this._('Data sent to Statistics Finland.'))
      } else {
        this.showError(this._('Error sending data to Statistics Finland.'))
      }
    },
    async copyReport (id) {
      let response = null
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/archivedreports/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      if (response && response.data) {
        let report = response.data
        let params = null
        try {
          params = JSON.parse(report.params)
        } catch(e) {
          return
        }
        params.id = 0
        this.EventBus.$emit('showCreateReportComponent', { shopId: this.shopId, events: [{ setCreateReportParams: params }]})
      }
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable,
    ReportActions
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['taskUpdate'] = (message) => {
        if (message && message.data && message.data.status === 'done') {
          return this.reload()
        }
      }
      events['setArchivedReportListParams'] = (message) => {
        if (message) {
          if (message.type) {
            this.type = message.type
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }

}

</script>
<style scoped>
.dark {
  background-color: #ECEFF1;
}
.report-buttons {
  margin-bottom: 10px;
}
.report-row {
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ced8dc;
}
</style>